export const SET_AUTH = "SET_AUTH";
